import { Pipe, PipeTransform } from '@angular/core';
import { StaticMessage } from '@shared/enums';
import { getStaticMessage } from '@shared/utils';

@Pipe({ name: 'downloadButtonDisabledTooltip' })
export class DownloadButtonDisabledTooltip implements PipeTransform {
  transform(
    isAppOnline: boolean,
    canDownloadDprFiles: boolean,
    dprCards: boolean
  ): string {
    if (!canDownloadDprFiles) {
      return getStaticMessage(
        StaticMessage.CanNotDownloadDataNoDownloadRightsTooltip
      );
    }

    if (!isAppOnline) {
      return getStaticMessage(StaticMessage.UnavailableInOfflineTooltip);
    }

    if (!dprCards) {
      return getStaticMessage(StaticMessage.CanNotDownloadDataNoDprsTooltip);
    }

    return null;
  }
}
